(function() {
  function initBirthdayPicker(id) {
    var MONTHS = [
      { s: 'Jan', f: 'January', d: 31 },
      { s: 'Feb', f: 'February', d: 29 },
      { s: 'Mar', f: 'March', d: 31 },
      { s: 'Apr', f: 'April', d: 30 },
      { s: 'May', f: 'May', d: 31 },
      { s: 'Jun', f: 'June', d: 30 },
      { s: 'Jul', f: 'July', d: 31 },
      { s: 'Aug', f: 'August', d: 31 },
      { s: 'Sep', f: 'September', d: 30 },
      { s: 'Oct', f: 'October', d: 31 },
      { s: 'Nov', f: 'November', d: 30 },
      { s: 'Dec', f: 'December', d: 31 }
    ];

    var field     = document.getElementById('bdp-field-'     + id);
    var dropdown  = document.getElementById('bdp-dropdown-'  + id);
    var display   = document.getElementById('bdp-display-'   + id);
    var clearBtn  = document.getElementById('bdp-clear-'     + id);
    var monthGrid = document.getElementById('bdp-months-'    + id);
    var dayGrid   = document.getElementById('bdp-days-'      + id);
    var backBtn   = document.getElementById('bdp-back-'      + id);
    var titleEl   = document.getElementById('bdp-title-'     + id);
    var dayVal    = document.getElementById('bdp-day-val-'   + id);
    var monthVal  = document.getElementById('bdp-month-val-' + id);

    if (!field) return;
    if (field.dataset.bdpInitialized === 'true') return;
    field.dataset.bdpInitialized = 'true';

    MONTHS.forEach(function(m, i) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'bdp-cell';
      btn.setAttribute('role', 'gridcell');
      btn.textContent = m.s;
      btn.addEventListener('click', function() {
        selMonth = i;
        buildDays(i);
        monthGrid.style.display = 'none';
        dayGrid.style.display   = 'grid';
        backBtn.style.display   = 'flex';
        titleEl.textContent     = m.f;
        highlightDays();
        highlightMonths();
      });
      monthGrid.appendChild(btn);
    });

    function buildDays(mi) {
      dayGrid.innerHTML = '';
      for (var d = 1; d <= MONTHS[mi].d; d++) {
        (function(day) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'bdp-cell';
          btn.setAttribute('role', 'gridcell');
          btn.textContent = day;
          btn.dataset.day = day;
          btn.addEventListener('click', function() {
            selDay = day;
            save();
            close();
          });
          dayGrid.appendChild(btn);
        })(d);
      }
    }

    function highlightMonths() {
      Array.from(monthGrid.children).forEach(function(btn, i) {
        btn.classList.toggle('is-selected', i === selMonth);
      });
    }

    function highlightDays() {
      Array.from(dayGrid.children).forEach(function(btn) {
        btn.classList.toggle('is-selected', parseInt(btn.dataset.day) === selDay);
      });
    }

    function save() {
      if (selMonth !== null && selDay !== null) {
        display.textContent = selDay + ' ' + MONTHS[selMonth].f;
        display.classList.add('has-value');
        dayVal.value   = selDay;
        monthVal.value = selMonth + 1;
        clearBtn.style.display = 'flex';
      }
    }

    function showMonths() {
      monthGrid.style.display = 'grid';
      dayGrid.style.display   = 'none';
      backBtn.style.display   = 'none';
      titleEl.textContent     = defaultTitleText;
      highlightMonths();
    }

    function open() {
      isOpen = true;
      dropdown.classList.add('is-open');
      field.classList.add('is-open');
      field.setAttribute('aria-expanded', 'true');
      if (selMonth !== null) {
        buildDays(selMonth);
        monthGrid.style.display = 'none';
        dayGrid.style.display   = 'grid';
        backBtn.style.display   = 'flex';
        titleEl.textContent     = MONTHS[selMonth].f;
        highlightDays();
      } else {
        showMonths();
      }
    }

    function close() {
      isOpen = false;
      dropdown.classList.remove('is-open');
      field.classList.remove('is-open');
      field.setAttribute('aria-expanded', 'false');
    }

    field.addEventListener('click', function(e) {
      if (clearBtn.contains(e.target)) return;
      isOpen ? close() : open();
    });

    field.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); isOpen ? close() : open(); }
    });

    backBtn.addEventListener('click', function(e) {
      e.stopPropagation();
      showMonths();
    });

    clearBtn.addEventListener('click', function(e) {
      e.stopPropagation();
      selMonth = null; selDay = null;
      display.textContent = defaultDisplayText;
      display.classList.remove('has-value');
      dayVal.value = ''; monthVal.value = '';
      clearBtn.style.display = 'none';
      if (isOpen) showMonths();
    });

    document.addEventListener('click', function(e) {
      if (isOpen && !field.closest('.birthday-picker-group').contains(e.target)) close();
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && isOpen) { close(); field.focus(); }
    });
  }

  document.querySelectorAll('[id^="bdp-field-"]').forEach(function(el) {
    initBirthdayPicker(el.id.replace('bdp-field-', ''));
  });
})();